module.exports = __webpack_public_path__ + "static/media/11NEPAD10.3d6a40e9.jpg";